export function emHero() {
	// Check if body has the 'em--masthead-hidden' class and remove it.
	const { body } = document;
	if (body.classList.contains('em--masthead-hidden')) {
		body.classList.remove('em--masthead-hidden');
	}

	// Immediately activate animations for elements within hero/masthead.
	const instantAnimatedEls = document.querySelectorAll('.em-hero [class*="em-animate--"]');
	instantAnimatedEls.forEach((el) => {
		el.className = el.className.replace('em-animate--', '');
	});

	// When mouse over a hot spot, add the 'is-active' class to it, and remove it from the other hot spots.
	const hotSpotItems = document.querySelectorAll('.em-hero__hot-spot-item');
	hotSpotItems.forEach((hotSpotItem) => {
		hotSpotItem.addEventListener('click', () => {
			hotSpotItem.classList.add('is-active');
			hotSpotItems.forEach((otherHotSpotItem) => {
				if (otherHotSpotItem !== hotSpotItem) {
					otherHotSpotItem.classList.remove('is-active');
				}
			});
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	emHero();
});
